import { LANGUAGES } from 'i18n';
import { BaseService } from './BaseService';
import { IClientBet } from '../widgets/Roulette/types';

export interface ICreatePendingBetRequestData {
  bets: IClientBet[];
  info: IClientBet[];
  timeStamp: number;
}

export interface IStreamLoadRequestData {
  sessionId: string;
  time: number;
  load: boolean;
}

class RestAPIService extends BaseService {
  public async createPendingBet(data: ICreatePendingBetRequestData) {
    const result = await this.post<ICreatePendingBetRequestData | null>('bets/create', data, {
      'Content-Type': 'application/json; charset=utf-8',
    });

    if (result.status === 201) {
      return result.data;
    }

    return null;
  }

  public async sendStreamLoadData(data: IStreamLoadRequestData) {
    return await this.post('loading', data, {
      'Content-Type': 'application/json; charset=utf-8',
    });
  }

  public async getGameRules(locale: LANGUAGES) {
    const route = `game-rules/${locale}`;

    return this.getAPI(route);
  }

  public async getHistory() {
    const route = `bets/history`;

    return this.getAPI(route);
  }
}

export const RestService = new RestAPIService();
